import { NgModule } from '@angular/core';

import { OnboardingSpotlightModalDirectiveModule } from '~app-client/onboarding/_internal/components';

import { OnboardingSpotlightTargetComponentModule } from '../_internal/components/spotlight-target/spotlight-target.component';

const MODULES_TO_IMPORT = [
	OnboardingSpotlightModalDirectiveModule,
	OnboardingSpotlightTargetComponentModule,
];

@NgModule({
	imports: [...MODULES_TO_IMPORT],
	exports: [...MODULES_TO_IMPORT],
})
export class OnboardingModule {}
